import { API_SALES_ORDER } from '@/services/SalesOrders'
import * as dynamic from '@/utils/dynamic'

export default ({ poStillOpen }) => ({
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  store: {
    get: {
      url: API_SALES_ORDER.GET_DYNAMIC,
      selected: [
        'rfq.poDate as poDate', 'rfq.po as po', 'baxpo', 'supplierCompany.name as supplierCompanyName',
        'rfq.customerCompany.name as customerCompanyName', 'entryDate', 'rfq.rfqType.title',
        'rfq.rfqType.title as rfqTypeTitle', 'rfqid', 'poStillOpen', 'supplierInvoiceNumber',
        'remarks',
        'approvedForPaymentByEmployee.name as approvedForPaymentByEmployeeName'
      ].join(','),
      filters: `poStillOpen==${poStillOpen}`,
      orderBy: { field: 'id', order: 'desc' }
    }
  },
  header: {
    controls: {
      isVisible: true,
      isRefresh: true,
      addNew: false,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('po-date')}",
      field: 'poDate',
      template: 'date',
      sortable: {
        custom: 'rfq.poDate'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('po')}",
      field: 'po',
      sortable: {
        custom: 'rfq.po'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('baxpo')}",
      field: 'baxpo'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('supplier')}",
      field: 'supplierCompanyName',
      sortable: {
        custom: 'supplierCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('customer')}",
      field: 'customerCompanyName',
      sortable: {
        custom: 'rfq.customerCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('rfq-type')}",
      field: 'rfqTypeTitle',
      sortable: {
        custom: 'rfq.rfqType.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('rfqid')}",
      field: 'rfqid'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('remarks')}",
      field: 'remarks'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('po-still-open')}",
      template: 'boolean',
      field: 'poStillOpen'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('entry-date')}",
      field: 'entryDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('approved-for-payment-by')}",
      field: 'approvedForPaymentByEmployeeName',
      sortable: {
        custom: 'approvedForPaymentByEmployee.name'
      }
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          valueTemplate: ({ value }) =>
            dynamic.mergeFilters(
              dynamic.makeFilter([
                'baxpo', 'remarks', 'awb', 'rfq.po', 'supplierCompany.name',
                'rfq.customerCompany.name', 'rfq.rfqType.title', 'approvedForPaymentByEmployee.name'
              ], value, dynamic.contains)
            ).join('&&'),
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '15rem'
          }
        }
      }
    ]
  },
  rowControls: {
  }
})
